import UniqueId from '../../services/uid/UniqueId';
import { AppState } from '../reducers/root';
import { OperationProgressState } from '../slices/operationProgress';

export const getProgressStateRoot = (state: AppState): OperationProgressState =>
  state.operationProgress;

export const getPendingOperationsCount = (state: AppState): number =>
  getProgressStateRoot(state).pendingCount;

export const hasPendingFormUpdates = (
  state: AppState,
  formId: UniqueId
): boolean =>
  (getProgressStateRoot(state).formUpdatesCountMap[formId] ?? 0) > 0;

export const hasPendingOperations = (state: AppState): boolean =>
  getPendingOperationsCount(state) > 0;
